(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/animated-backgrounds.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/animated-backgrounds.js');
"use strict";


const branding = svs.tickets.data.templateConfig.branding;
const AnimatedBackgrounds = _ref => {
  var _window$matchMedia;
  let {
    ticketInfo
  } = _ref;
  const {
    animatedBackgrounds
  } = svs.tickets.play.components;
  const backgroundMap = {
    snowflakes: animatedBackgrounds.SnowyBackground,
    hearts: animatedBackgrounds.HeartBackground,
    greenFeathers: animatedBackgrounds.FeatherBackground('green'),
    pinkFeathers: animatedBackgrounds.FeatherBackground('pink'),
    dandelion: animatedBackgrounds.DandelionBackground,
    sakura: animatedBackgrounds.SakuraBackground,
    flowers: animatedBackgrounds.FlowerBackground,
    autumnLeaf: animatedBackgrounds.AutumnLeafBackground,
    fireworks: animatedBackgrounds.FireworksBackground,
    bubbles: animatedBackgrounds.BubbleBackground,
    pacman: animatedBackgrounds.PacmanBackground 
  };
  const prefersReducedMotion = Boolean((_window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches);
  const Background = backgroundMap[ticketInfo.animatedBackground];
  if (prefersReducedMotion) {
    return null;
  }
  if (!Background && branding === 'skrapspel') {
    if (ticketInfo.type.indexOf('pacman') + 1) {
      return React.createElement(animatedBackgrounds.PacmanBackground, null);
    }
    return React.createElement("div", {
      className: "animated-background-container"
    }, React.createElement(animatedBackgrounds.BubbleBackground, {
      ticketType: ticketInfo.type
    }));
  } else if (!Background) {
    return null;
  }
  return React.createElement(Background, null);
};
setGlobal('svs.tickets.play.components.AnimatedBackgrounds', AnimatedBackgrounds);

 })(window);